import React, { useState, useEffect } from "react";
import { Loading } from 'jobin-ui-components'

import ButtonImage from "../../../button/ButtonImage";
import { createInvoice as createInvoice_, getInvoiceInfo, downloadInvoicePDF, getInvoiceUrl } from "../../../../utils/ParserUtilities";


import InvoiceCell from "./InvoiceCell";
import BillingDataModal from "../../../modal/BillingDataModal";

import "../../../../styles/search/detail/job-detail-info.css";
import { useStateValue } from "../../../../state/context";

export default function HoldedInvoiceContainer() {
    const [{ jobDetails, agent }] = useStateValue();

    const [loading, setLoading] = useState(false);
  
    const [invoicesArray, setInvoicesArray] = useState([]);
    const [showBillingDataModal, setShowBillingDataModal] = useState(false);
    const [clientData, setClientData] = useState({});

    const style = {
        total: {
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            textAlign: "right",
            marginTop: 16
        },
        totalLabel: {
            fontSize: 16,
            fontWeight: "bold"
        },
        statusLabel: {
            fontSize: 12,
        }
    };

    useEffect(() => {
        initializeInvoices();
        getClientData()
    }, []);

    // Inicializar el array de facturas (simulamos una factura base)
    const initializeInvoices = async (invoiceArray = null) => {
        setLoading(true)
        let jobState = jobDetails?.job?.get("State")
        let invoices
        if (!invoiceArray) {
            invoices = jobDetails?.paymentsArray.map(payment=>payment)
            invoices = invoices?.pop()?.get("HoldedInvoices")
            if (!invoices || !Array.isArray(invoices)) {
                setInvoicesArray([]);
                setLoading(false)
                return null
            }
        } else {
            invoices = invoiceArray
        }
        let invoiceDataArray = []
        invoices.forEach(async (invoice) => {
            try {
                let result = await getInvoiceInfo({ invoiceId: invoice, type: (jobState == "eliminado" || jobState == "falso") ? "creditnote" : "invoice" })
                const invoiceFormated = {
                    ...result,
                    createdAt: new Date(result.date * 1000).toDateString()
                };
                invoiceDataArray.push(invoiceFormated)
                setInvoicesArray(invoiceDataArray);
                setLoading(false)
            } catch (error) {
                console.error(error)
            }
        })
    };
    const getClientData = async () => {
        setLoading(true)
        let client = jobDetails?.job.get("CreatedBy")
        let data = {
            fullName: client?.get("Name"),
            contactID: client?.get("NIF"),
        }
        setClientData(data);
        setLoading(false)
    };


    // Manejar las opciones del menú de cada factura
    const invoiceOptionSelected = async (invoice, option) => {
        let jobState = jobDetails?.job?.get("State")

        setInvoiceData(invoice);
        switch (option.id) {
            case "view-in-holded":
                let url = await getInvoiceUrl({ invoiceId: invoice.id, type: (jobState == "eliminado" || jobState == "falso") ? "creditnote" : "invoice" })
                window.open(url, "_blank")
                break;
            case "view-details":
                setShowInvoiceDetails(true)
                break;
            case "download-pdf":
                downloadInvoicePDF_({ invoice: invoice, type: (jobState == "eliminado" || jobState == "falso") ? "creditnote" : "invoice" });
                break;
            default:
                break;
        }
    };


    // Crear factura simplificada
    const handleCreateSimplifiedInvoice = async () => {
        setShowBillingDataModal(false);
        await createInvoice({ defaultData: true });
    };

    // Crear factura personalizada con datos de facturación
    const handleCreateCustomInvoice = async (customBillingData) => {
        setShowBillingDataModal(false);
        await createInvoice({ ...customBillingData });
    };

    // Cerrar modal de datos de facturación
    const handleCloseBillingDataModal = () => {
        setShowBillingDataModal(false);
    };

    // Crear factura en Holded
    const createInvoice = async ({ defaultData = false, fullName = null, contactID = null, address = null, city = null, postalCode = null, province = null }) => {
        try {
            setLoading(true);
            setError(null);
            let data = {
                jobId: jobDetails.job.id,
                isDefaulContact: defaultData,
                agentId: agent.agentId,
                fullName: fullName,
                contactID: contactID,
                address: address,
                city: city,
                postalCode: postalCode,
                province: province,
            }
            let result = await createInvoice_(data)
            if (result) {
                let tempArray = [...invoicesArray, result.id]
                setInvoicesArray(tempArray)
                initializeInvoices(tempArray)
            } else {
                setError(true)
            }
            setLoading(false);

        } catch (error) {
            setLoading(false);
            setError(true)

        }
    };


    // Descargar PDF de la factura
    const downloadInvoicePDF_ = async ({ invoice, type }) => {
        try {
            setLoading(true);
            setError(null);

            const response = await downloadInvoicePDF({ invoiceId: invoice.id, type: type });

            if (response.success && response.base64) {
                const linkSource = `data:application/pdf;base64,${response.base64}`;
                const downloadLink = document.createElement("a");
                const fileName = `HoldedInvoice${invoice.docNumber}.pdf`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click()


            } else {
                throw new Error('No se pudo obtener el PDF de la factura');
            }
        } catch (error) {
            setError(`Error al descargar PDF: ${error.message}`);
            console.error('Error descargando PDF:', error);
            alert(`Error al descargar PDF: ${error.message}`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className="infoContainer">
            {showBillingDataModal && (
                <BillingDataModal
                    isOpen={showBillingDataModal}
                    onClose={handleCloseBillingDataModal}
                    onCreateSimplified={handleCreateSimplifiedInvoice}
                    onCreateCustom={handleCreateCustomInvoice}
                    initialData={clientData}
                />
            )}

            <div style={{ display: "flex" }}>

                {invoicesArray.length > 0 && <label className="title"> Total:{invoicesArray?.map((invoice) => {
                    return invoice.subtotal
                }).reduce((partialSum, a) => partialSum + a, 0)}€</label>}
                <label className="title">Facturas Holded</label>
                <ButtonImage
                    buttonText=""
                    src={require("../../../../assets/add.svg").default}
                    onClick={() => {
                        setShowBillingDataModal(true);
                    }}
                    disabled={false}
                />
            </div>
            {loading ? (
                <Loading />
            ) : (
                <div>
                    <div style={{ marginTop: 12, display: "flex", flexDirection: "column" }}>

                        {invoicesArray?.map((item, index) => {
                            return (
                                <InvoiceCell
                                    key={"invoice" + index}
                                    permissions={true}
                                    buttonHidden={false}
                                    invoice={item}
                                    jobId={item.jobId}
                                    agentId={item.agentId}
                                    buttonItemSelected_={(option) => {
                                        invoiceOptionSelected(item, option);
                                    }}
                                />
                            );
                        })}
                    </div>
                    <div style={style.total}>
                        {invoicesArray?.length <= 0 && <label style={style.totalLabel}>
                            Estado:Sin facturas
                        </label>}
                    </div>
                </div>
            )}
        </section>
    );
} 